<template>
  <div>
    <custom-toolbar
      :total="$store.getters['withdraw/total']"
      title="Withdraws"
      @refresh="getWithdraws"
    />
     <v-card class="mb-6 mt-6">
       <div class="m-2">
        <v-row class="ml-5 mr-5">
           <v-col cols="12" md="4">
              <v-text-field
                v-model="$store.state.withdraw.field.search"
                label="Rechercher"
                outlined
                dense
                clearable
                @input="getWithdrawsByFields"
              ></v-text-field>
           </v-col>

        </v-row>
      </div>
    </v-card>
    <v-card>
      <v-data-table
        :loading="loading"
        loading-text="Chargement.."
        :headers="headers"
        :items="$store.getters['withdraw/withdraws']"
        :items-per-page="$store.state.withdraw.field.paginate"
        :page.sync="currentPage"
        dense
        hide-default-footer
        @page-count="currentPage = $event"
      >
        <template #[`item.created_at`]="{item}">
          {{ formattingDate(item.created_at) }}
        </template>

         <template #[`item.partner`]="{item}">
          {{ item.partner ? (item.partner.name || item.partner.phone) : '-' }}
        </template>

         <template #[`item.amount`]="{item}">
           {{ formatAmount(item.amount) }}
        </template>

        <template #[`item.status`]="{item}">
          <v-chip small :color="getStatusColor(item.status)">
            {{ getStatusLabel(item.status) }}
          </v-chip>
        </template>

        <template #[`item.phone`]="{item}">
          {{ item.phone || '-' }}
        </template>

        <template #[`item.operator`]="{item}">
          {{ item.operator ? item.operator.label : '-' }}
        </template>

        <template #[`item.actions`]="{ item }">
          <buttons-group
            :item="item"
            :edit="false"
            :remove="false"
            :lock="false"
            :status="false"
             @view="openItem(item)"
          />
<!--          <v-btn
            v-if="item.status && item.status.code === 'CREATED'"
            color="primary"
            small
            @click="openValidateDialog(item)"
          >
            Valider
          </v-btn>-->
        </template>

      </v-data-table>

      <v-card-text class="pt-2">
        <v-row>
          <v-col cols="2">
             <v-select
               v-model="$store.state.withdraw.field.paginate"
               :items="[10, 20, 50, 100]"
               label="Lignes par page"
               outlined
               dense
               hide-details
               @change="getWithdrawsByFields"
              ></v-select>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-pagination
              v-model="currentPage"
              total-visible="6"
              :length="lastPage"
              @input="getWithdraws"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confirmation</v-card-title>
        <v-card-text>Voulez-vous vraiment valider ce retrait ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogConfirm = false">Non</v-btn>
          <v-btn color="primary" text @click="validate">Oui</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomToolbar from '@core/components/toolbar/CustomToolbar'
import ButtonsGroup from '@core/components/buttons/ButtonsGroup'
import { ref, onMounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import { formatDate } from '@core/date/dateFunctions'
import { intToCurrency, notify } from '@core/dynamicComponents/dynamicComponents'
import ConfirmDialog from '@core/components/dialogs/ConfirmDialog' // Assuming this is needed if dialogConfirm is used

export default {
  name: 'Withdraws',
  components: {
    CustomToolbar,
    ButtonsGroup,
    ConfirmDialog
  },
  setup() {
    const loading = ref(false)
    const currentPage = ref(1)
    const lastPage = ref(1)
    const validatingId = ref(null)
    const dialogConfirm = ref(false)
    const isDialogVisible = ref(false)
    const selectedItem = ref(null)


    const headers = [
      { text: 'PARTENAIRE', value: 'partner' },
      { text: 'MONTANT', value: 'amount' },
      { text: 'TELEPHONE', value: 'phone' },
      { text: 'OPERATEUR', value: 'operator' },
      { text: 'STATUT', value: 'status' },
      { text: 'DATE', value: 'created_at' },
      { text: 'ACTIONS', value: 'actions', sortable: false },
    ]

    const formattingDate = date => formatDate(date)
    const formatAmount = amount => intToCurrency(store.state.user.lang, {
      style: 'currency',
      currency: 'XAF',
      minimumFractionDigits: 0,
    }, amount)

    const getStatusColor = (status) => {
        if (!status) return 'secondary'
        return status.color || 'secondary'
    }

    const getStatusLabel = (status) => {
        if (!status) return 'Inconnu'
        return status.label || status.code
    }

    const getWithdraws = (page = 1) => {
      loading.value = true
      store.dispatch('withdraw/getWithdrawalsList', { page, field: store.state.withdraw.field }).then(() => {
        currentPage.value = store.getters['withdraw/current_page']
        lastPage.value = store.getters['withdraw/last_page']
        loading.value = false
      }).catch(error => {
        console.error(error)
        loading.value = false
      })
    }

    const getWithdrawsByFields = () => {
         getWithdraws(1)
    }

    const validateRequest = (item) => {
        validatingId.value = item.id
        store.dispatch('withdraw/validateWithdrawal', item.id).then(() => {
            notify(true, true, 'Retrait validé avec succès')
            getWithdraws(currentPage.value)
        }).catch(error => {
             console.error(error)
             notify(true, true, 'Erreur lors de la validation')
        }).finally(() => {
            validatingId.value = null
        })
    }

    const openValidateDialog = (item) => {
      selectedItem.value = item
      dialogConfirm.value = true
    }

    const openItem = (item) => {
      router.push({ name: 'withdrawal-details', params: { id: item.id } })
    }

    const validate = () => {
      if (selectedItem.value) {
        validateRequest(selectedItem.value)
      }
      dialogConfirm.value = false
    }

    onMounted(() => {
      getWithdraws()
    })

    return {
      headers,
      loading,
      currentPage,
      lastPage,
      dialogConfirm,
      isDialogVisible,
      openValidateDialog,
      openItem,
      validate,
      page: currentPage,
      itemsPerPage: store.state.withdraw.field.paginate,
      getWithdraws,
      formattingDate,
      formatAmount,
      getWithdrawsByFields,
      getStatusColor,
      getStatusLabel,
      validateRequest,
      validatingId
    }

  }
}
</script>
